/* Colour scheme toggle: light <-> dark.

   Until the visitor chooses, the site follows prefers-color-scheme. The first
   click stores an explicit choice, which then wins on every page.

   The inline script in default.hbs applies the stored class before first
   paint; this file only handles the UI and the click behaviour, so there is
   no flash of the wrong scheme. */
(function () {
    'use strict';

    var KEY = 'es-scheme';
    var root = document.documentElement;
    var media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

    function stored() {
        try {
            var v = localStorage.getItem(KEY);
            return v === 'light' || v === 'dark' ? v : null;
        } catch (e) {
            return null;
        }
    }

    /* The scheme actually on screen, whether chosen or inherited from the OS */
    function current() {
        return stored() || (media && media.matches ? 'dark' : 'light');
    }

    function apply(scheme) {
        root.classList.remove('es-light', 'es-dark');
        root.classList.add('es-' + scheme);
        root.style.colorScheme = scheme;

        var label = scheme === 'dark' ? 'DARK' : 'LIGHT';
        var buttons = document.querySelectorAll('[data-scheme-toggle]');

        for (var i = 0; i < buttons.length; i++) {
            var btn = buttons[i];
            btn.setAttribute('aria-pressed', scheme === 'dark' ? 'true' : 'false');
            btn.setAttribute('aria-label', 'Switch to ' + (scheme === 'dark' ? 'light' : 'dark') + ' mode');

            var text = btn.querySelector('[data-scheme-label]');
            if (text) {
                text.textContent = label;
            }
        }
    }

    apply(current());

    /* Reveal only once the label matches reality */
    root.classList.add('es-scheme-ready');

    document.addEventListener('click', function (event) {
        var btn = event.target.closest ? event.target.closest('[data-scheme-toggle]') : null;
        if (!btn) {
            return;
        }

        var next = current() === 'dark' ? 'light' : 'dark';
        try {
            localStorage.setItem(KEY, next);
        } catch (e) {
            /* storage unavailable — the choice applies for this page view only */
        }
        apply(next);
    });

    /* Follow the OS until the visitor has made an explicit choice */
    if (media) {
        var onChange = function () {
            if (!stored()) {
                apply(media.matches ? 'dark' : 'light');
            }
        };
        if (media.addEventListener) {
            media.addEventListener('change', onChange);
        } else if (media.addListener) {
            media.addListener(onChange);
        }
    }

    /* Cover image: only switch the masthead to its dark, light-copy treatment
       once the image has really decoded. Ghost marks .has-image whenever a
       cover is configured, which would otherwise leave light text on a paper
       background when the image fails or is still loading. */
    (function coverState() {
        var header = document.querySelector('.gh-header.is-classic.has-image');
        if (!header) {
            return;
        }
        var img = header.querySelector('.gh-header-image');
        if (!img) {
            return;
        }
        var confirm = function () {
            if (img.naturalWidth > 0) {
                header.classList.add('es-has-cover');
            }
        };
        if (img.complete) {
            confirm();
        } else {
            img.addEventListener('load', confirm);
        }
    }());
}());
